export const CREATE_BANK_PAYMENT_RETURN  = 'CREATE_BANK_PAYMENT_RETURN';
export const GET_BANK_PAYMENT_RETURNS  = 'GET_BANK_PAYMENT_RETURNS';
export const BANK_PAYMENT_RETURN_REQUEST  = 'BANK_PAYMENT_RETURN_REQUEST';
export const DELETE_BANK_PAYMENT_RETURN  = 'DELETE_BANK_PAYMENT_RETURN';
export const UPDATE_BANK_PAYMENT_RETURN  = 'UPDATE_BANK_PAYMENT_RETURN';
export const BANK_PAYMENT_RETURN_REQUEST_SUCCESS  = 'BANK_PAYMENT_RETURN_REQUEST_SUCCESS';
export const BANK_PAYMENT_RETURN_REQUEST_FAILURE  = 'BANK_PAYMENT_RETURN_REQUEST_FAILURE';